import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 92px);
  min-height: calc(100vh - 92px);

  ${MEDIA_MIN_SM} {
    height: 100%;
    min-height: 100vh;
  }
`;

export const heading = (clientId: string) => css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: var(${SpacingToken.Spacing6}) var(${SpacingToken.Spacing5});
  color: var(${DesignToken.ContentBasicPrimary});

  ${MEDIA_MIN_SM} {
    padding: var(${SpacingToken.Spacing6}) var(${SpacingToken.Spacing8});
  }

  > div {
    display: flex;
  }

  ${clientId === import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID &&
  `
    border-bottom: 1px solid var(${DesignToken.DecorGray700});
  `}
`;

export const logoContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const actionButtonsContainer = css`
  display: flex;
  align-items: center;
`;

export const mainContainer = (clientId: string) => css`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: flex-start;
  height: 100%;

  ${clientId === import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID &&
  `
    ${MEDIA_MIN_SM} {
      padding: var(${SpacingToken.Spacing7}) 0;
      margin: 0 15vw;
      border-left: 1px solid var(${DesignToken.DecorGray700});
      border-right: 1px solid var(${DesignToken.DecorGray700});
    } 
  `}
`;

export const footer = (clientId: string) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: var(${SpacingToken.Spacing4}) 0;
  color: var(${DesignToken.ContentBasicSecondary});

  ${clientId === import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID &&
  `
    padding: var(${SpacingToken.Spacing8}) 0;
    border-top: 1px solid var(${DesignToken.DecorGray700});

    ${MEDIA_MIN_SM} {
      margin: 0 15vw;
      border-top: 0;
      border-left: 1px solid var(${DesignToken.DecorGray700});
      border-right: 1px solid var(${DesignToken.DecorGray700});

      &::before {
        content: '';
        position: absolute;
        bottom: 84px;
        left: 0vw;
        right: 0vw;
        height: 1px;
        background-color: var(${DesignToken.DecorGray700});
        z-index: -1;
      }
    }
  `}
`;

export const textLogoFull = css`
  max-height: 52px;
  max-width: 90%;
  margin-bottom: 14px;
`;

export const textLogo = css`
  height: 16px;
  width: auto;
  margin-bottom: -4px;
`;

export const contextEventDecorator = css`
  display: none;

  ${MEDIA_MIN_SM} {
    display: block;
    position: absolute;
    left: 15.05vw;
    bottom: 84px;
    width: 256px;
    height: 204px;
    z-index: -1;
  }
`;
